<template>
  <div class="cursor-pointer group">
    <!-- Image Area -->
    <div
      class="relative w-full mb-3 overflow-hidden bg-gray-100 rounded-lg aspect-square"
    >
      <div
        v-if="total_stock <= 0"
        class="absolute inset-0 z-30 flex items-center justify-center bg-black/40"
      >
        <span
          class="px-4 py-2 font-bold leading-none tracking-widest text-white border-2 border-white"
          >已售完</span
        >
      </div>

      <div
        v-else-if="product_time_status == 'end' || event_time_status == 'end'"
        class="absolute inset-0 z-30 flex items-center justify-center bg-black/40"
      >
        <span
          class="px-4 py-2 font-bold leading-none tracking-widest text-white border-2 border-white"
          >已結束販售</span
        >
      </div>

      <div
        v-else-if="
          product_time_status == 'prepare' || event_time_status == 'prepare'
        "
        class="absolute inset-0 z-30 flex items-center justify-center bg-black/40"
      >
        <span
          class="px-4 py-2 font-bold leading-none tracking-widest text-white border-2 border-white"
          >尚未開始販售</span
        >
      </div>

      <div
        v-if="
          product_time_status == 'start' || product_time_status == 'prepare'
        "
        class="absolute bottom-0 left-0 w-full bg-black/80 backdrop-blur-sm text-white text-[10px] sm:text-xs py-2 text-center font-medium tracking-wide z-10 countdown-timer"
      >
        <span class="mr-1">{{
          product_time_status == "start" ? "🔥 剩餘" : "等待"
        }}</span>
        <span class="font-mono text-rose-400 timer-display">{{
          remaining_time
        }}</span>
      </div>

      <router-link
        v-if="event_mode == false"
        :to="`/product/${product_data.GoodsID}`"
        class="relative z-0 block w-full h-full"
      >
        <img
          :src="$ImageUrl(product_data.Image)"
          :alt="product_data.Title"
          class="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105"
        />
      </router-link>
      <div
        v-else
        @click="$emit('open-quick-shop', product_data.GoodsID)"
        class="relative z-0 block w-full h-full"
      >
        <img
          :src="$ImageUrl(product_data.Image)"
          :alt="product_data.Title"
          class="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <button
        @click="$emit('open-quick-shop', product_data.GoodsID)"
        class="absolute z-20 items-center justify-center hidden w-10 h-10 text-black transition-all duration-300 translate-y-2 bg-white rounded-full shadow-md opacity-0 md:flex bottom-4 right-4 group-hover:opacity-100 group-hover:translate-y-0 hover:bg-black hover:text-white"
      >
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
          ></path>
        </svg>
      </button>
    </div>

    <!-- Info Area -->
    <div class="space-y-1">
      <h3
        class="text-sm font-medium text-gray-900 group-hover:underline decoration-1 underline-offset-4"
      >
        {{ product_data.Title }}
      </h3>
      <div class="flex items-center justify-between">
        <div>
          <span class="mr-1 text-xs text-gray-400 line-through" v-if="product_data.Price != product_data.SellPrice"
            >${{ $MoneyFormat(product_data.Price) }}</span
          ><span class="text-sm font-bold text-rose-600"
            >${{ $MoneyFormat(product_data.SellPrice) }}</span
          >
        </div>
      </div>
      <!-- Promo Tags -->
      <div class="flex flex-wrap gap-1 mt-2">
        <span
          v-if="product_data.Discount.indexOf('特價') != -1"
          class="px-1.5 py-0.5 text-[10px] font-bold bg-rose-50 text-rose-600 border border-rose-100 rounded"
          >打折</span
        ><span
          v-if="product_data.Discount.indexOf('折扣') != -1"
          class="px-1.5 py-0.5 text-[10px] font-bold bg-rose-50 text-orange-600 border border-rose-100 rounded"
          >折扣</span
        ><span
          v-if="product_data.Discount.indexOf('免運') != -1"
          class="px-1.5 py-0.5 text-[10px] font-bold bg-emerald-50 text-emerald-600 border border-emerald-100 rounded"
          >免運</span
        ><span
          v-if="product_data.Discount.indexOf('贈品') != -1"
          class="px-1.5 py-0.5 text-[10px] font-bold bg-yellow-50 text-yellow-600 border border-yellow-100 rounded"
          >贈品</span
        ><span
          v-if="product_data.Discount.indexOf('組合價') != -1"
          class="px-1.5 py-0.5 text-[10px] font-bold bg-sky-50 text-sky-600 border border-sky-100 rounded"
          >組合價</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductCard",
  props: {
    product_data: {
      type: Object,
      required: true,
      default: null,
    },
    event_mode: {
      type: Boolean,
      required: false,
      default: false,
    },
    event_time_status: {
      type: String,
      required: false,
      default: "none",
    },
  },
  data() {
    return {
      count_down_timer: null,
      remaining_time: "",
    };
  },
  methods: {
    SetTimer() {
      if (this.product_data.GoodsTimeEnd == null) {
        return false;
      }
      this.count_down_timer != null ? clearInterval(this.count_down_timer) : "";
      this.count_down_timer = setInterval(() => {
        // 檢查商品資料是否仍然存在
        if (!this.product_data || !this.product_data.GoodsTimeEnd) {
          clearInterval(this.count_down_timer);
          return false;
        }
        // 設置倒數計時: 結束時間 - 當前時間
        // 當前時間
        let time = new Date();
        let nowTime = time.getTime(); // 獲取當前毫秒數
        let end_time = new Date(
          this.product_data.GoodsTimeEnd.replace(" ", "T")
        ).getTime();
        let start_time = new Date(
          this.product_data.GoodsTimeStart.replace(" ", "T")
        ).getTime();

        if (nowTime < start_time) {
          this.remaining_time = this.GetCountDownTimeString(
            start_time,
            nowTime
          );
          return true;
        }

        if (end_time < nowTime) {
          clearInterval(this.count_down_timer);
          return false;
        }

        this.remaining_time = this.GetCountDownTimeString(end_time, nowTime);
      }, 1000);
    },
    GetCountDownTimeString(end_time, nowTime) {
      // 倒數計時: 差值
      let offsetTime = (end_time - nowTime) / 1000; // ** 以秒為單位
      let sec = parseInt(offsetTime % 60); // 秒
      let min = parseInt((offsetTime / 60) % 60); // 分 ex: 90秒
      let hr = parseInt((offsetTime / 60 / 60) % 24); // 時
      let day = parseInt(offsetTime / 60 / 60 / 24); // 天

      let time_string = "";
      if (day > 0) {
        time_string += `${day}天 `;
      }
      time_string += `${hr.toString().padStart(2, "0")}:${min
        .toString()
        .padStart(2, "0")}:${sec.toString().padStart(2, "0")}`;
      return time_string;
    },
  },
  computed: {
    product_time_status() {
      if (this.product_data == null) {
        return "none";
      }
      if (
        this.product_data.GoodsTimeStart == null ||
        this.product_data.GoodsTimeEnd == null
      ) {
        return "none";
      }
      let time = new Date();
      let nowTime = time.getTime(); // 獲取當前毫秒數
      let start_time = new Date(
        this.product_data.GoodsTimeStart.replace(" ", "T")
      ).getTime();
      let end_time = new Date(
        this.product_data.GoodsTimeEnd.replace(" ", "T")
      ).getTime();
      if (nowTime < start_time) {
        return "prepare";
      }
      if (nowTime >= end_time) {
        return "end";
      }
      return "start";
    },
    total_stock() {
      let stock_count = 0;
      this.product_data.Stock.forEach((stock) => {
        stock.Status == "Y" ? (stock_count += stock.Stock) : "";
      });
      return stock_count;
    },
  },
  watch: {
    product_data() {
      this.SetTimer();
    },
  },
  created() {
    this.SetTimer();
  },
};
</script>
